import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarRefresh = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "calendar-refresh" }),
		/* @__PURE__ */ _jsx("path", { d: "M2.5,16.5A.5.5,0,0,1,2,16V7.5A.5.5,0,0,1,2.5,7H16a.5.5,0,0,1,.5.5V9.57a7.281,7.281,0,0,1,2,0V3a1,1,0,0,0-1-1H15a.25.25,0,0,1-.25-.25v-1a.75.75,0,1,0-1.5,0V4.5a.75.75,0,1,1-1.5,0v-2a.5.5,0,0,0-.5-.5H7a.25.25,0,0,1-.25-.25v-1a.75.75,0,0,0-1.5,0V4.5a.75.75,0,1,1-1.5,0v-2a.5.5,0,0,0-.5-.5H1A1,1,0,0,0,0,3V16.5a2,2,0,0,0,2,2H9.569a7.281,7.281,0,0,1,0-2Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M22.769,18.6a1,1,0,0,0-1.27.623,4.093,4.093,0,0,1-7.074,1.238l1.886-1.885a.5.5,0,0,0-.354-.854H11.5a.5.5,0,0,0-.5.5v4.458a.5.5,0,0,0,.854.353l1.155-1.155a6.088,6.088,0,0,0,10.383-2.008A1,1,0,0,0,22.769,18.6Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M23.691,11.773a.5.5,0,0,0-.545.109l-1.21,1.21A6.1,6.1,0,0,0,11.567,15.13a1,1,0,0,0,1.893.648,4.094,4.094,0,0,1,7.054-1.264l-1.825,1.825a.5.5,0,0,0,.354.853H23.5a.5.5,0,0,0,.5-.5V12.235A.5.5,0,0,0,23.691,11.773Z" })
	]
});
export default SvgCalendarRefresh;
